/* eslint-disable */

import * as companyManagementService from "../../services/company";
import * as settings from "../../services/settings";

import { Button, Col, Row, Spin, Table, notification } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";

import { ModalCreateRoutes } from "./modal/modalCreateRoutes";
import { ModalDelete } from "../model/modal/delete";
import permissions from "../../../configs/permission";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { usePermission } from "../../hooks/usePermission";

const initPage = { limit: 10, page: 1, total: 1 };

export const CreateCompanyRoutes = ({ t, detailData }) => {
  const { hasPermission, isCompanyFullAccess } = usePermission();
  const can = (p) => isCompanyFullAccess || hasPermission(p);
  const { accessToken } = useAccessToken();
  const [search, setSearch] = useState(initPage);
  const [companyRoutesData, setCompanyRoutesData] = useState([]);
  const [editCompanyRoutesData, setEditCompanyRoutesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prepareDeleteData, setPrepareDeleteData] = useState({});

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onDeleteCompanyRoutes = async (data) => {
    let prepareDeleteCompanyRoutes = {
      id: data.id,
    };
    setLoading(true);
    try {
      const response = await companyManagementService.deleteCompanyRoutes(accessToken, prepareDeleteCompanyRoutes);
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Delete routes success"}</>);
      setPrepareDeleteData({});
      setIsOpenDelete(false);
      fetchCompanyRoutes();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[CreateCompanyRoutes] onDeleteCompanyRoutes: ", err);
      setLoading(false);
    }
  };

  const fetchCompanyRoutes = useCallback(
    async (param) => {
      setLoading(true);
      const params = { ...param };
      let updateById = detailData.id;
      try {
        const data = await companyManagementService.getCompanyRoutes(accessToken, updateById, params);
        setCompanyRoutesData(data);
        setSearch({ ...param });
      } catch (err) {
        console.error("[CreateCompanyRoutes] fetchCompanyRoutes: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      }
      setLoading(false);
    },
    [accessToken]
  );

  useEffect(() => {
    setLoading(true);
    if (accessToken) {
      fetchCompanyRoutes();
      setLoading(false);
    }
  }, [accessToken, fetchCompanyRoutes]);

  const columns = [
    {
      title: t("Company_Create.Create_Routes.Table_No"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("Company_Create.Create_Routes.Table_Origin"),
      dataIndex: "origin",
      key: "origin",
      render: (_, record) => {
        const origin = record.app_warehouse_app_companyroute_origin_idToapp_warehouse.warehouse_code || "";
        return <p>{origin}</p>;
      },
    },
    {
      title: t("Company_Create.Create_Routes.Table_Destination"),
      dataIndex: "destination",
      key: "destination",
      render: (_, record) => {
        const destination = record.app_warehouse_app_companyroute_destination_idToapp_warehouse.warehouse_code || "";
        return <p>{destination}</p>;
      },
    },
    {
      title: t("Company_Table.Table_Edit"),
      dataIndex: "edit",
      key: "edit",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!can(permissions.CompanyRoute.CHANGE)}
          onClick={() => {
            setIsEdit(true);
            setEditCompanyRoutesData(record);
            showModal();
          }}
        >
          <EditOutlined />
        </Button>
      ),
    },

    {
      title: t("Company_Table.Table_Delete"),
      dataIndex: "delete",
      key: "delete",
      render: (_, record) => (
        <Button
          type="link"
          disabled={!can(permissions.CompanyRoute.DELETE)}
          onClick={() => {
            setIsOpenDelete(true);
            setPrepareDeleteData(record);
          }}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row align="middle" justify="end">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={companyRoutesData}
              scroll={{ x: "1440px", y: "500px" }}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: search.limit,
                current: search.page,
                pageSize: search.limit,
                total: search.total,
                onChange: (page, limit) => fetchCompany({ ...search, page, limit }),
                showSizeChanger: true,
              }}
              style={{ cursor: "pointer" }}
            />
          </Col>
          {can(permissions.CompanyRoute.ADD) && (
            <Row justify="end" style={{ marginTop: "10px" }}>
              <Col span={24}>
                <Button
                  type="primary"
                  onClick={() => {
                    showModal();
                    setIsEdit(false);
                  }}
                  style={{ marginRight: "10px", justifyContent: "end" }}
                >
                  {t("Button_Company.BTN_Add_Routes")}
                </Button>
              </Col>
            </Row>
          )}
          <ModalCreateRoutes
            isModalOpen={isModalOpen}
            handleOk={handleOk}
            handleCancel={handleCancel}
            fetchCompanyRoutes={fetchCompanyRoutes}
            editCompanyRoutesData={editCompanyRoutesData}
            companyRoutesData={companyRoutesData}
            detailData={detailData}
            setIsModalOpen={setIsModalOpen}
            isEdit={isEdit}
            t={t}
          />
        </Row>
        <ModalDelete
          isOpen={isOpenDelete}
          handleCloseModal={() => {
            setIsOpenDelete(false);
          }}
          onClick={() => {
            onDeleteCompanyRoutes(prepareDeleteData);
          }}
          dataDetail={prepareDeleteData}
          t={t}
        />
      </Spin>
    </>
  );
};
